export default "__VITE_ASSET__CPsLQsXr__"